import { render, staticRenderFns } from "./selectIcon.vue?vue&type=template&id=6cf79ac9&lang=pug"
import script from "./selectIcon.vue?vue&type=script&lang=js"
export * from "./selectIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports